export const Api = {
  Club: {
    List: 'clubs/get-clubs-list'
  }
};



// WEBPACK FOOTER //
// ./src/app/models/api.config.ts